export default {
  package: { label: 'Packages Only', value: 1 },
  paid:    { label: 'Drop-In + Packages', value: 0 }
};
